import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { useExtensionPermissions } from '@/api/use-extension-permissions';
import { numberOfMissedCallsToPauseAtom } from '@/store/atoms';

export const useSetPauseOnMissedCall = () => {
  const setPauseThreshold = useSetAtom(numberOfMissedCallsToPauseAtom);
  const { data: permissions } = useExtensionPermissions();

  useEffect(() => {
    if (permissions) {
      const value =
        typeof permissions.pauseAfterMissedCall === 'number'
          ? permissions.pauseAfterMissedCall
          : 0;
      setPauseThreshold(value);
    }
  }, [permissions, setPauseThreshold]);
};
